define((require) => {
    "use strict";

    const ImprovedView                    = require("zbone/ImprovedView.js");
    const LabelCharacterPropertiesView    = require("ui/experience/widgets/button/LabelCharacterPropertiesView");
    const template                        = require("ui/experience/widgets/button/LabelPropertiesView.tpl");

    return ImprovedView.extend("LabelPropertiesView", {

        className: "label-properties",

        template,

        regions: {
            characterProperties: ".character-properties"
        },

        ui: {
            contentContainer: ".content-container",
            buttonLabelRow: ".button-label-row"
        },

        bindings: {
            ".button-label-input": "label"
        },

        onShow() {
            this.characterProperties.show(new LabelCharacterPropertiesView({model: this.model}));
        },

        hide() {
            this.ui.buttonLabelRow.addClass("hidden");
            this.characterProperties.currentView.hide();
        },

        unhide() {
            this.ui.buttonLabelRow.removeClass("hidden");
            this.characterProperties.currentView.unhide();
        }


    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/LabelPropertiesView.js